export default __webpack_public_path__ + "static/media/logo-upgas.c04f0960.png";